import loadable from '@loadable/component';

export const loadables = {
  'subsite-rer-gray': loadable.lib(() => import('./rer-gray')),
};
